export default {
  path: '/subject-categories',
  component: () => import(/* webpackChunkName: "subject-categories" */ './SubjectCategories'),
  meta: {
    requiresAuth: true
  }
}
